import { type FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ImageComponent } from '@/components/Image';
import { getSSCdnImgUrl } from '@/helpers/cdn';
import { isCdnImg, useButtonAction } from '@/modules/promo';

import { ScTopGamesCard } from './styles';

interface ITopGamesCardProps {
  games: string[];
  staticCard?: boolean;
}

export const TopGamesCard: FC<ITopGamesCardProps> = ({ games, staticCard }) => {
  const { t } = useTranslation('common');
  const { buttonAction } = useButtonAction();

  const containerRef = useRef<HTMLDivElement>(null);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (staticCard) return;

    const el = containerRef.current;
    if (!el) return;

    let direction = 1;
    let frame: number;

    const step = () => {
      if (!paused) {
        el.scrollTop += direction;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
          direction = -1;
        } else if (el.scrollTop <= 0) {
          direction = 1;
        }
      }
      frame = requestAnimationFrame(step);
    };

    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, [paused, staticCard]);

  return (
    <ScTopGamesCard
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      ref={containerRef}
      staticScroll={staticCard}
    >
      <p className="title">{t('common:game.topGames')}</p>
      <div className="games">
        {games.map((game, index) => (
          <div
            className="game"
            key={index}
            {...(staticCard ? {} : buttonAction)}
          >
            <ImageComponent
              alt={`Top game ${index + 1}`}
              height={148}
              src={isCdnImg(game) ? game : getSSCdnImgUrl(game)}
              width={148}
            />
          </div>
        ))}
      </div>
    </ScTopGamesCard>
  );
};
